export default {"src":"/_next/static/image/public/images/icons/email-icon.0d20c31df9d1e086b4321785fe27c6a6.svg","height":20,"width":20};